import {
    IonButton,
    IonCol, 
    IonIcon,
    IonImg,
    IonItem,
    IonLabel,
    IonNote,
    IonRow,
    IonButtons
} from '@ionic/react';
import { helpCircle } from 'ionicons/icons';
import { Browser } from '@capacitor/browser';

import React, { Component }  from 'react';
import { UIElement } from "../components/NServer";
import { GetLanguage } from "../language/Language";

export interface AddressData {
    id : number,
    address : string
}

interface HelpButProp {
    topic : string
}
  
const HelpBut : React.FC<HelpButProp> = ({ topic }) => {
    const click = () => {
        Browser.open({ url: "https://nwallet.me/d/help.php?d="+topic+"&lang="+GetLanguage() });
    }

    return (
        <IonButtons className={ UIElement("help_but") } slot="end">
            <IonButton fill="clear" onClick={click}><IonIcon icon={helpCircle} size="large" /></IonButton>
        </IonButtons>
    );
};
  
export default HelpBut;